import { motion, useAnimationFrame } from "framer-motion";
import { Button, Tooltip } from "prism-react";
import { useRef } from "react";

interface Props {
  isConnected: boolean;
  onRefresh(): void;
}

export const RefreshButton: React.FC<Props> = ({ isConnected, onRefresh }) => {
  const ref = useRef<HTMLDivElement>(null);
  const rotate = useRef(0);
  useAnimationFrame(() => {
    const speed = isConnected ? Math.min(rotate.current % 360, 20) : 10;
    if (ref.current && (!isConnected || rotate.current % 360 !== 0)) {
      rotate.current += speed;
      ref.current.style.transform = `rotateZ(${rotate.current}deg)`;
    }
  });

  return (
    <Tooltip content="Refresh">
      <Button
        onClick={onRefresh}
        style={{
          padding: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <motion.div
          ref={ref}
          style={{ transformOrigin: "center", width: 16, height: 16 }}
        >
          <svg style={{ width: 16, height: 16 }} viewBox="0 0 16 16">
            <motion.path
              animate={{
                opacity: isConnected ? 1 : 0,
                scale: isConnected ? 1 : 0.8,
              }}
              clipRule="evenodd"
              d="M2.6665 7.99984C2.6665 5.05426 5.05405 2.6665 7.99911 2.6665C10.3201 2.6665 12.2961 4.14985 13.0284 6.222C13.0726 6.34706 13.1615 6.44354 13.2708 6.49984H9C8.72386 6.49984 8.5 6.7237 8.5 6.99984C8.5 7.27598 8.72386 7.49984 9 7.49984H13.7333C14.0647 7.49984 14.3333 7.23121 14.3333 6.89984V2.1665C14.3333 1.89036 14.1095 1.6665 13.8333 1.6665C13.5572 1.6665 13.3333 1.89036 13.3333 2.1665V4.58531C12.2078 2.83016 10.2398 1.6665 7.99911 1.6665C4.50165 1.6665 1.6665 4.50209 1.6665 7.99984C1.6665 11.4976 4.50165 14.3332 7.99911 14.3332C10.3437 14.3332 12.3901 13.0586 13.4842 11.1668C13.6225 10.9278 13.5408 10.6219 13.3018 10.4837C13.0627 10.3454 12.7569 10.4271 12.6186 10.6662C11.6958 12.2616 9.97227 13.3332 7.99911 13.3332C5.05405 13.3332 2.6665 10.9454 2.6665 7.99984Z"
              fill={isConnected ? "currentColor" : "#AC9CFF"}
              fillRule="evenodd"
            />

            <motion.path
              animate={{
                opacity: isConnected ? 0 : 1,
              }}
              clipRule="evenodd"
              d="M8.02021 1.53345C4.43782 1.53345 1.5332 4.43585 1.5332 8.01678C1.5332 11.5977 4.43782 14.5001 8.02021 14.5001C10.4218 14.5001 12.518 13.1955 13.639 11.2589C13.7773 11.0199 13.6957 10.714 13.4567 10.5757C13.2177 10.4374 12.9119 10.519 12.7735 10.758C11.8241 12.3982 10.0507 13.5001 8.02021 13.5001C4.98953 13.5001 2.5332 11.0449 2.5332 8.01678C2.5332 4.98871 4.98953 2.53345 8.02021 2.53345C9 2.53345 9 1.5 8.02021 1.53345Z"
              fill={isConnected ? "currentColor" : "#AC9CFF"}
              fillRule="evenodd"
            />
          </svg>
        </motion.div>
      </Button>
    </Tooltip>
  );
};
